import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';

// Shared components
//import PortletContent from 'components/PortletContent';

// Material components
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
//import Crop75OutlinedIcon from '@material-ui/icons/Crop75Outlined';
//import { makeStyles } from '@material-ui/core/styles';
//import Badge from '@material-ui/core/Badge';
import Popover from '@material-ui/core/Popover';
import {getLastStatusStepByNode} from '../../../../../services/getLastStatusStepByNode'
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { Grid } from '@material-ui/core';
import BounceLoader from 'react-spinners/BounceLoader';
// Component styles
import moment from 'moment'
import 'moment/locale/es'
import { TableCell } from '@material-ui/core';
moment.locale('es')
const dateMoment=((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))



class stepsAvailability extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            step:this.props.step,
            objective:this.props.objective.objetivo_id,
            isLoad:true,
            user:sessionStorage.getItem("user"),
            token:sessionStorage.getItem("key"),
            open:false,
            anchor:null
        };
    }

    componentDidMount() {
        this.processData();
    }

   
    processData = () => {
        const {user, token, objective,step}=this.state
            getLastStatusStepByNode(user, objective, token, step.id_paso).then(value=>{
                this.setState({
                    isLoad:false,
                    stateNodeStep:value.Nodos
                })
                
            })
            
        
    }

    handleCloseFilter = () => {
        this.setState({
            anchor: null,
            open:false
        });
    };
    openFilter=(event)=>{
        this.setState({
            open:true,
            anchor:event.currentTarget
        })
    }

    createTdEmpty = () => {
        //console.log(objetive, totalSteps)
        const { classes } = this.props;
        return <TableCell className={classes.tableCellCargando} style={{borderBottom: "4px solid #e4dede"}}>
                <CircularProgress
                variant="indeterminate"

                size={12}
                thickness={4}
                />
        </TableCell>
    }

    callBounce=(node)=>{
        var bounce=<BounceLoader sizeUnit={"px"} size={18} color="#41B900" loading={true}/>
        if(node.status==="downtime"){
            bounce=<BounceLoader sizeUnit={"px"} size={18} color=" #C2272D" loading={true}/>
        }

        return <Grid item lg={3} xl={3} xs={3} md={3}>
                    {bounce}
                </Grid>
    }

    createTd = (step, open, anchor) => {
        //console.log(step)
        const {stateNodeStep}= this.state
        var state=step.estado_paso
        const { classes } = this.props;
        var bounce=<div onClick={this.openFilter} className={classes.shape}/>
        if(state==="Downtime"){
            bounce=<div onClick={this.openFilter} className={classes.shapeDowntime}/>
        }
        if(state==="Parcial"){
            bounce=<div onClick={this.openFilter} className={classes.shapeParcial}/>
        }
        if(state==="no_monitoreo"){
            bounce=<div onClick={this.openFilter} className={classes.shapeNoMon}/>
        }
        var tableCell=<TableCell  style={{borderBottom: "0px", padding:"2px"}}>
                        <Tooltip title={step.nombre_paso} placement="top-start">{bounce}</Tooltip>
                            <Popover open={open}
                            anchorEl={anchor}
                            onClose={this.handleCloseFilter}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                                }}
                                transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                                }}
                        >
                            
                        {stateNodeStep.map(node=>(
                            <Grid container
                                spacing={1}
                                direction="row"
                                justify="center"
                                alignItems="center"
                            >
                                <Grid item lg={9} xl={9} xs={9} md={9}>
                                    <Typography style={{fontWeight:"bold", color:"rgb(102, 120, 138)", fontFamily:"Roboto, Helvetica, Arial, sans-serif"}}>{node.nombre}</Typography>
                                </Grid>
                                {this.callBounce(node)}
                                
                            </Grid>
                        ))}
                            
                        </Popover>
                    </TableCell>
        return tableCell
    }
    render() {
        const { isLoad,step,open,anchor} = this.state;
        const { classes } = this.props;
        if (isLoad===true) {
            return(
               this.createTdEmpty()
            )
        }else if(isLoad===false){
            return (
                this.createTd(step, open, anchor)
            )
        }
    }
}



export default compose(withRouter, withStyles(styles))(stepsAvailability);